import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { DashboardsService } from "../dashboards-service/dashboards.service";
import { ApplicationType } from "@app/views-interfaces/ApplicationType.enum";

export const nonJobsGuard: CanActivateFn = async () => {
    const dashboardsService = inject(DashboardsService);
    const router = inject(Router);
    const dashboards = await dashboardsService.getDashboardsList();
    const haveNonJobs = dashboards?.some((d) => d.ApplicationType !== ApplicationType.JobsBilling);
    if (haveNonJobs) {
        return true;
    } else {
        return router.createUrlTree(["/unauthorizedroute"]);
    }
};
